import cn from "classnames"

import { Flex, Tag, Text } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"

import styles from "./RuleTitle.module.scss"

import type { RuleTitleProps } from "./RuleTitle.types"

export const RuleTitle = ({ type, kind = "agent" }: RuleTitleProps) => {
  const { t } = useTranslation()
  const isAllow = type === "allow"

  return (
    <Flex align="center" gap={10}>
      <Tag
        className={cn(styles.tag, {
          [styles.tagAllow]: isAllow,
          [styles.tagNotAllow]: !isAllow
        })}
      >
        {isAllow ? "Allow" : "Don't allow"}
      </Tag>
      <Text type="secondary">
        {t(`governance.ai.ruleTitle.${type}.${kind}`)}
      </Text>
    </Flex>
  )
}
